module.exports = "/images/warning.svg?e6aaaa8797302cffdd6f4d9a9432c6ba";